import { useState, type ReactNode } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ApiError } from "@/lib/api/http"

const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          /** На 401/403/404 повтор бесполезен — оставляем единичный retry только на сетевые ошибки. */
          if (error instanceof ApiError) {
            if (error.status === 401 || error.status === 403 || error.status === 404) return false
            return failureCount < 1
          }
          return failureCount < 1
        },
      },
      mutations: {
        retry: false,
      },
    },
  })

export const QueryProvider = ({ children }: { children: ReactNode }) => {
  const [client] = useState(() => createQueryClient())
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}
